// Homepage

import { buildProducts } from '../components/buildProducts';
import { getImagesByColor, getFeaturedImagesByColor } from '../components/images';
import { handleize } from '../helper/functions';
import 'unfetch/polyfill';
import 'es6-promise/auto';
import * as cart from '@shopify/theme-cart';
// import { rebuildCart } from '../components/cart';
import 'slick-carousel';
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

// Settings for Slick Carousels
jQuery('.js-featured-bottoms').slick({
  dots: true,
  arrows: true,
  slidesToShow: 2,
  slidesToScroll: 2
});

jQuery('.js-colors').slick({
  dots: false,
  arrows: false,
  slidesToShow: 13,
  slidesToScroll: 13
});

jQuery('.js-bundle-open').click(function () {
  jQuery('.js-bundle-selector').fadeIn();
});

jQuery('.js-bundle-close').click(function () {
  jQuery('.js-bundle-selector').fadeOut();
});

// Build Homepage Collections
(async () => {
  const containers = document.querySelectorAll('.js-collection');
  for (const container of containers) {
    await buildProducts(container);
  }

  // get every product in the bundle

  const bundles = document.querySelectorAll('.js-bundle');

  for (const bundle of bundles) {
    const new_product = await fetch(`/products/${bundle.dataset.handle}.json`)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });

    const product = new_product.product;

    const featured_images = getFeaturedImagesByColor(product)[bundle.dataset.color];

    let featured_image = featured_images ? featured_images[0] : '';

    featured_image = featured_image.replace('.jpg', '_500x.jpg');
    featured_image = featured_image.replace('.png', '_500x.png');

    const featured_image_el = featured_image ? `<img src='${featured_image}' loading='lazy' />` : '';

    const add_button_el = `
                    <div class='bundle-add js-bundle-add lg:w-24 lg:h-24 w-16 h-16 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-full bg-light-blue flex items-center justify-center opacity-0 cursor-pointer'>
                        <svg width="27px" height="28px" viewBox="0 0 27 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="01-Homepage" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="HP_Launch_Logo" transform="translate(-827.000000, -2762.000000)" stroke="#ffffff" stroke-width="2"> <g id="3-for-48" transform="translate(0.000000, 2631.000000)"> <line x1="840.5" y1="131.231263" x2="840.5" y2="158.731263" id="Line-4-Copy"></line> <line x1="854" y1="145.231263" x2="827" y2="145.231263" id="Line-4-Copy-2"></line> </g> </g> </g> </svg>
                    </div>
                    `;

    let size_options = product.options.find((e) => e.name.toLowerCase() === 'size');
    let size_options_el = '';

    let checked = 'checked';

    if (size_options) {
      for (const size_option of size_options.values) {
        size_options_el += `
                    <span>
                        <input type="radio" id="${product.id}-${size_option}" name="${product.id}-size" value="${size_option}" class='hidden' ${checked}>
                        <label for="${product.id}-${size_option}">${size_option}</label>
                    </span>
                `;
        checked = '';
      }
    }

    const sizes_el = `
                    <div class='bundle-sizes p-4 text-13px flex items-center justify-center bg-white absolute bottom-0 left-0 right-0 w-full z-10'>
                        ${size_options_el}
                    </div>
                    `;

    bundle.innerHTML = featured_image_el + add_button_el + sizes_el;

    bundle.querySelector('.js-bundle-add').addEventListener('click', () => {
      const color = bundle.dataset.color;
      const size = bundle.querySelector(`input[name='${product.id}-size']:checked`).value;

      const variant = product.variants.find((e) => e.title == color + ' / ' + size);

      cart
        .addItem(variant.id)
        .then((item) => {
          cart.getState().then((state) => {
            // rebuildCart(state);
            return state;
          });

          document.body.classList.add('cart--open');
        })
        .catch((e) => {
          if (e.status == 422) {
            alert('Out of stock.');
          }
        });
    });
  }

  // Daily Lace Quick Shop
  function getOneVariantOfEachColor(product, option_index) {
    const result = [];
    const map = new Map();

    for (const item of product.variants) {
      if (!map.has(item[option_index])) {
        map.set(item[option_index], true);
        result.push(item);
      }
    }

    return result;
  }

  function setSelectors(prod, el) {
    let images = el.querySelectorAll('[data-image]');

    for (let image of images) {
      image.onload = function () {
        el.querySelector('.js-loader').style.display = 'none';
      };
    }

    let radios = prod ? el.querySelectorAll(`[data-type="radio-color"][data-product_id="${prod.id}"]`) : [];

    for (let radio of radios) {
      if (!radio.classList.contains('has-listener')) {
        radio.classList.add('has-listener');
      }

      radio.addEventListener('change', async () => {
        let variant_id = parseInt(radio.dataset.variantId);

        // change the prices

        let variants = prod.variants;
        let selected = variants.find((e) => e.id === variant_id);

        let currency = document.querySelector('.js-currency').dataset.currency;
        let price_with_currency = '$' + selected.price / 100;
        let compare_at_price_with_currency = '$' + selected.compare_at_price / 100;
        if (window.Shopify.routes.root.length > 1) {
          price_with_currency = currency.replace(/{{[\s\S]+}}/g, selected.price / 100);
          compare_at_price_with_currency = currency.replace(/{{[\s\S]+}}/g, selected.compare_at_price / 100);
        }

        el.querySelector('.js-variant-price-' + prod.id).innerHTML = price_with_currency;

        if (el.querySelector('.js-variant-compare-at-price-' + prod.id)) {
          if (selected.compare_at_price) {
            el.querySelector('.js-variant-compare-at-price-' + prod.id).innerHTML = compare_at_price_with_currency;
          } else {
            el.querySelector('.js-variant-compare-at-price-' + prod.id).innerHTML = '';
          }
        }

        // change the images
        let images_obj = getImagesByColor(prod);

        let images = images_obj[radio.dataset.color];

        if (images) {
          // let srcset = buildSrcset(images);

          el.querySelector('.js-loader').style.display = 'block';

          let imgFileType = '.jpg';

          if (images[0].includes('.png')) {
            imgFileType = '.png';
          }

          if (images[0]) {
            let prodImg1 = images[0].replace('https:', ''),
              src1Desktop = prodImg1.replace(imgFileType, `_x1600${imgFileType}`),
              src1Mobile = prodImg1.replace(imgFileType, `_x900${imgFileType}`);

            el.querySelector(`[data-image="1"][data-product_id="${prod.id}"]`).src = images[0];
            el.querySelector(`[data-image="1"][data-src_desktop="${prod.id}"]`).setAttribute('srcset', src1Desktop);
            el.querySelector(`[data-image="1"][data-src_mobile="${prod.id}"]`).setAttribute('srcset', src1Mobile);
          }

          if (images[1]) {
            let prodImg2 = images[1].replace('https:', ''),
              src2Desktop = prodImg2.replace(imgFileType, `_x1600${imgFileType}`),
              src2Mobile = prodImg2.replace(imgFileType, `_x900${imgFileType}`);

            el.querySelector(`[data-image="2"][data-product_id="${prod.id}"]`).src = images[1];
            el.querySelector(`[data-image="2"][data-src_desktop="${prod.id}"]`).setAttribute('srcset', src2Desktop);
            el.querySelector(`[data-image="2"][data-src_mobile="${prod.id}"]`).setAttribute('srcset', src2Mobile);
            el.querySelector(`[data-image="2"][data-product_id="${prod.id}"]`).style.display = '';
          } else {
            el.querySelector(`[data-image="2"][data-product_id="${prod.id}"]`).style.display = 'none';
          }
        }
      });
    }
  }
  // Quick-shop is only used for bundles, no longer used for quick-shop.liquid or product-quick-shop.liquid
  const quick_shop_products = document.querySelectorAll('.js-quick-shop-product-data');

  for (const qs_product of quick_shop_products) {
    if (qs_product.dataset.handle) {
      let product = await fetch(`/products/${qs_product.dataset.handle}.js`)
        .then((response) => response.json())
        .then((data) => {
          return data;
        });

      let images;

      // get the option for color
      let color_option = product.options.find((e) => e.name.toLowerCase() === 'color');
      // create a colors selector element
      let colors_selector = '';

      // if color is an option, create swatches
      if (color_option) {
        let images_obj = getImagesByColor(product);

        // get the option index for color
        let color_index = 'option' + color_option.position;
        let variants_to_check;

        // get the variants, one of each color
        variants_to_check = getOneVariantOfEachColor(product, color_index);

        let index = 0;
        for (let variant of variants_to_check) {
          if (images === undefined) {
            images = images_obj[variant[color_index]];
          }

          let checked = index == 0 ? 'checked' : '';

          let color_swatch = `
                        <div class='color-item quick-shop-color-item'>
                            <input type='radio' name='${product.id}-color' data-type='radio-color' data-color='${variant[color_index]}' value='${variant[color_index]}' data-variant-id='${variant.id}' data-product_id='${product.id}' id='option-${variant.id}' ${checked} />
                            <label class='text-0px' for='option-${variant.id}' data-option='${handleize(variant[color_index])}'>${variant[color_index]}</label>
                        </div>`;
          colors_selector = colors_selector + color_swatch;

          index++;

          if (index == 5) {
            if (variants_to_check.length - index != 0) {
              colors_selector =
                colors_selector +
                `<span class='text-13px tracking-0_3px text-gray'>+${variants_to_check.length - 5}</span>`;
            }
            break;
          }
        }
      } else {
        images = product.images;
      }

      let size_options = product.options.find((e) => e.name.toLowerCase() === 'size');
      let size_options_el = '';

      if (size_options) {
        let checked = 'checked';
        for (const size_option of size_options.values) {
          size_options_el += `
                        <span class="quick-shop-size-item">
                            <input type="radio" id="${product.id}-${size_option}" name="${product.id}-size" value="${size_option}" class='hidden' ${checked}>
                            <label for="${product.id}-${size_option}">${size_option}</label>
                        </span>
                    `;
          checked = '';
        }
      }

      let type_options = product.options.find((e) => e.name.toLowerCase() === 'type');
      let type_options_el = '';

      if (type_options) {
        let checked = 'checked';
        for (const type_option of type_options.values) {
          type_options_el += `
                        <span class="quick-shop-type-item">
                            <input type="radio" id="${product.id}-${type_option}" name="${product.id}-size" value="${type_option}" class='hidden' ${checked}>
                            <label for="${product.id}-${type_option}">${type_option}</label>
                        </span>
                    `;
          checked = '';
        }
      }

      let compare_at_price = product.variants[0].compare_at_price / 100;
      let price = product.variants[0].price / 100;

      let currency = document.querySelector('.js-currency').dataset.currency;
      let price_with_currency = '$' + price;
      let compare_at_price_with_currency = '$' + compare_at_price;
      if (window.Shopify.routes.root.length > 1) {
        price_with_currency = currency.replace(/{{[\s\S]+}}/g, price);
        compare_at_price_with_currency = currency.replace(/{{[\s\S]+}}/g, compare_at_price);
      }

      let compare_at_price_html =
        isNaN(compare_at_price) || compare_at_price == 0
          ? ''
          : '<span class="mr-1 line-through text-gray js-variant-compare-at-price-' +
            product.id +
            '">' +
            compare_at_price_with_currency +
            '</span>';
      let price_html = price
        ? '<span class="js-variant-price-' + product.id + '">' + price_with_currency + '</span>'
        : '';

      let imgFileType = '.jpg',
        images1 = images[0],
        images2 = images[1];

      var img1 = '',
        img2 = '';

      if (images1) {
        if (images1.includes('.png')) {
          imgFileType = '.png';
        }

        let prodImg1 = images1.replace('https:', '');

        let src1Desktop = prodImg1.replace(imgFileType, `_x1600${imgFileType}`),
          src1Mobile = prodImg1.replace(imgFileType, `_x900${imgFileType}`);

        img1 = `
                    <picture>
                        <source data-image="1" data-src_mobile="${product.id}" srcset="${src1Mobile}" media="(max-width: 767px)">
                        <source data-image="1" data-src_desktop="${product.id}" srcset="${src1Desktop}" media="(min-width: 768px)">
                        <img loading="lazy"
                                src="${prodImg1}"
                                class="w-full h-full object-cover inset-0 absolute"
                                data-image="1"
                                data-product_id="${product.id}"
                                alt="">
                    </picture>
                `;
      } else {
        img1 = `
                <picture>
                    <source data-image="1" data-src_mobile="${product.id}" srcset="" media="(max-width: 767px)">
                    <source data-image="1" data-src_desktop="${product.id}" srcset="" media="(min-width: 768px)">
                    <img loading="lazy"
                            src=""
                            class="w-full h-full object-cover inset-0 absolute"
                            data-image="1"
                            data-product_id="${product.id}"
                            alt=""
                            style="display:none;">
                </picture>
            `;
      }

      if (images2) {
        if (images2.includes('.png')) {
          imgFileType = '.png';
        } else {
          imgFileType = '.jpg';
        }

        let prodImg2 = images2.replace('https:', '');

        let src2Desktop = prodImg2.replace(imgFileType, `_x1600${imgFileType}`),
          src2Mobile = prodImg2.replace(imgFileType, `_x900${imgFileType}`);

        img2 = `
                    <picture>
                        <source data-image="2" data-src_mobile="${product.id}" srcset="${src2Mobile}" media="(max-width: 767px)">
                        <source data-image="2" data-src_desktop="${product.id}" srcset="${src2Desktop}" media="(min-width: 768px)">
                        <img loading="lazy"
                            src="${images2}"
                            class="w-full h-full object-cover inset-0 absolute opacity-0 hover:opacity-100 transition duration-300"
                            data-image="2"
                            data-product_id="${product.id}"
                            alt="">
                    </picture>
                `;
      } else {
        img2 = `
                    <picture>
                        <source data-image="2" data-src_mobile="${product.id}" srcset="" media="(max-width: 767px)">
                        <source data-image="2" data-src_desktop="${product.id}" srcset="" media="(min-width: 768px)">
                        <img loading="lazy"
                            src=""
                            class="w-full h-full object-cover inset-0 absolute opacity-0 hover:opacity-100 transition duration-300"
                            data-image="2"
                            data-product_id="${product.id}"
                            alt=""
                            style="display:none;">
                    </picture>
                `;
      }

      const url = qs_product.dataset.url
        ? qs_product.dataset.url
        : `${window.Shopify.routes.root}products/${product.handle}`;

      // let promoMessage = '';
      // if (product.tags.includes('3-for Discount Function')) {
      //     promoMessage = '<p class="text-light-blue">or any 3 for $54</p>';
      // }
      // if (product.tags.includes('BFCM-BOGO')) {
      //     promoMessage = '<p class="text-orange">Buy One, Get One Free</p>';
      // }

      let item = `<div>
                            <a href="${url}" class="block relative pt-135 w-full h-0 mb-4">
                                ${img1}
                                ${img2}
                                <div class='js-loader absolute z-10 bg-white bg-opacity-20 w-full h-full inset-0'><div class="lds-roller absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
                            </a>

                            <a href="${url}" class="block mb-4 text-13px">
                                <span class="block font-bold">${product.title}</span>
                                <div>
                                    ${compare_at_price_html}${price_html}
                                </div>
                            </a>

                        </div>
                        <div>
                            <div class="flex flex-wrap items-center" role="radiogroup" aria-labelledby="radiogroup-${product.id}">
                                <p id="radiogroup-${product.id}" class="screen-reader-only">Color swatches for ${product.title}</p>
                                ${colors_selector}
                            </div>
                            <div class="flex flex-wrap items-center">
                                ${size_options_el}
                            </div>
                            <div class="flex flex-wrap items-center">
                                ${type_options_el}
                            </div>
                            <button class="js-quick-shop-add-button text-14px font-bold underline mt-3">
                                Add To Bag
                            </button>
                        </div>`;

      // add the products to the DOM before adding the event listeners
      // el.insertAdjacentHTML('beforeend', item)

      qs_product.innerHTML = item;

      qs_product.classList.add('built');

      // set the selectors
      setSelectors(product, qs_product);

      // Add to cart functionality
      qs_product.querySelector('.js-quick-shop-add-button').addEventListener('click', () => {
        let radios = qs_product.querySelectorAll('input[type=radio]');

        let selected = [];

        // set the selected variant
        for (var j = 0; j < radios.length; j++) {
          if (radios[j].checked) {
            selected.push(radios[j].value);
          }
        }

        let variant_title = selected.join(' / ');

        const variant = product.variants.find((e) => e.title == variant_title);

        cart
          .addItem(variant.id)
          .then((item) => {
            cart.getState().then((state) => {
              // rebuildCart(state);
              return state;
            });

            document.body.classList.add('cart--open');
          })
          .catch((e) => {
            if (e.status == 422) {
              alert('Out of stock.');
            }
          });
      });
    }
  }
})();
